import React, { useState } from "react";
import { Link as RouterLink } from "react-router-dom";
import logo from "../../assets/images/logo.png";

const NAV_LINKS = [
  { label: "Home", href: "/#home" },
  { label: "Services", href: "/#hl-services" },
  { label: "Download App", href: "/#download" },
  { label: "Contact Us", href: "#contact" },
];

export default function LandingHeader() {
  const [open, setOpen] = useState(false);

  return (
    <header className="hl-header">
      <div className="hl-header__inner">
        <RouterLink to="/" className="hl-header__brand" onClick={() => setOpen(false)}>
          <img src={logo} alt="Boost Zone" />
        </RouterLink>

        <nav className={`hl-header__nav ${open ? "is-open" : ""}`}>
          {NAV_LINKS.map((link) => (
            <a key={link.href} href={link.href} onClick={() => setOpen(false)}>
              {link.label}
            </a>
          ))}
        </nav>

        <div className="hl-header__actions">
          <button
            type="button"
            className="hl-header__toggle"
            aria-label="Toggle menu"
            onClick={() => setOpen((v) => !v)}
          >
            <i className={`bi ${open ? "bi-x-lg" : "bi-list"}`} />
          </button>
        </div>
      </div>
    </header>
  );
}
